import * as React from "react";
import { BasePureComponent } from "./BaseComponent";
import { Trad } from "./";
import * as Dati from "../Dati";
import * as DatiRCP from "../DatiRCP";
import * as Glob from "../Globale";
import { CampiPolizza } from "../components/";

interface IAccordionCampiPolizzaProps {
    Info?: { [I: string]: Dati.CInfoCampo };
    DatoPolizza: any;
    Identificatore: string;
    Limiti: Dati.Dictionary<number>;
    OnChange: (e: React.FormEvent<any> | string, valore?: any) => any;
    OnChangeDeroga: (e: React.FormEvent<any>, tipo: string, verso: string) => any;
    OnBlur: (e: React.FormEvent<any> | string, valore: any) => any;
    Gruppo: string;
    Riga?: number;
    DimensioneGrafica?: number;
    Abilitato?: boolean;
    Indice: number;
    ConfirmedSteps?: string[];
    OnStepConfirmation?: (id: string) => void;
    MaxClient? : number;
}

export class AccordionCampiPolizza extends BasePureComponent<IAccordionCampiPolizzaProps> {
    private _Identificatore: string;

    public constructor(props: any) {
        super(props);
    }

    public render() {
        if (this.props.Identificatore == "DatoRCPPolizza") this._Identificatore = this.props.Identificatore;
        else this._Identificatore = this.props.Identificatore + ".DatoRCPPolizza";
        return (
            <div className="card-header active">
                <a
                    href={"#kt_accordion_1_item_" + this.props.Indice + "_body"}
                    className="card-title collapsed"
                    role="tab"
                    id={"kt_accordion_1_item_" + this.props.Indice + "_head"}
                    data-toggle="collapse"
                    aria-expanded="false"
                >
                    <span className="accordion__item-icon">
                        <i className="fa flaticon-edit-1"></i>
                    </span>
                    <span className="accordion__item-icon">{Trad.Trad("Questionario")}</span>
                    <span className="kt-accordion__item-mode"></span>
                </a>
                <div
                    className="kt-accordion__itekt-body collapse"
                    id={"kt_accordion_1_item_" + this.props.Indice + "_body"}
                    role="tabpanel"
                    aria-labelledby={"kt_accordion_1_item_" + this.props.Indice + "_head"}
                    data-parent="#kt_accordion_1"
                >
                    <div className="tab-content  kt--padding-30">
                        <div className="">
                            <CampiPolizza
                                Gruppo={this.props.Gruppo}
                                Riga={this.props.Riga}
                                Info={this.props.Info}
                                DatoPolizza={this.props.DatoPolizza}
                                Identificatore={this._Identificatore}
                                Limiti={this.props.Limiti}
                                OnChange={this.props.OnChange}
                                OnChangeDeroga={this.props.OnChangeDeroga}
                                OnBlur={this.props.OnBlur}
                                DimensioneGrafica={this.props.DimensioneGrafica}
                                Abilitato={this.props.Abilitato}
                                ConfirmedSteps={this.props.ConfirmedSteps}
                                OnStepConfirmation={this.props.OnStepConfirmation}
                                MaxClient={this.props.MaxClient}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AccordionCampiPolizza.tsx